import React from 'react'
import { Flex } from 'antd'
import clsx from 'clsx'

export type CandidateAttributesProps = {
    positive?: string[]
    negative?: string[]
    className?: string
}

export function CandidateAttributes({ positive, negative, className }: CandidateAttributesProps) {
    return (
        <Flex
            vertical
            gap="small"
            className={clsx('text-left', className)}
        >
            {positive && positive.length > 0 && (
                <ol className="flex gap-1 flex-col">
                    {positive.map((attribute, index) => (
                        <li
                            key={index}
                            className="flex gap-1"
                        >
                            <span>✅</span> <span>{attribute}</span>
                        </li>
                    ))}
                </ol>
            )}
            {negative && negative.length > 0 && (
                <ol className="flex gap-1 flex-col">
                    {negative.map((attribute, index) => (
                        <li
                            key={index}
                            className="flex gap-1"
                        >
                            <span>➖</span> <span>{attribute}</span>
                        </li>
                    ))}
                </ol>
            )}
        </Flex>
    )
}
